import { atom } from 'jotai';
import type { UndoRedoEvents } from '../../../../modernization-common/undo-redo/types';
import { undoRedoAtoms } from '../../../../modernization-common/undo-redo/undo-redo';
import type { TemplateEvent, UndoableEventPayloads } from '../../types/skeleton-template-builder.type';
import { EVENTS, UNDOABLE_EVENTS } from '../../types/skeleton-template-builder.type';
import { commandConfig } from './commands/command-config';
import { selectedNodeIdAtom, templateNodesAtom } from './template-atoms';
const {
  dispatch: undoRedoDispatchAtom,
  canUndo: canUndoAtom,
  canRedo: canRedoAtom
} = undoRedoAtoms<void, UndoableEventPayloads>(commandConfig);
export { canUndoAtom, canRedoAtom };
export const templateDispatchAtom = atom(undefined, (get, set, action: TemplateEvent | UndoRedoEvents) => {
  switch (action.type) {
    case 'UNDO':
    case 'REDO':
      set(undoRedoDispatchAtom, action);
      return;
    case EVENTS.SELECT_NODE:
      set(selectedNodeIdAtom, action.nodeId);
      return;
    case EVENTS.MOVE_NODE:
      {
        const nodes = get(templateNodesAtom);
        set(templateNodesAtom, nodes.map(n => n.id === action.nodeId ? {
          ...n,
          x: action.x,
          y: action.y
        } : n));
        return;
      }
    case EVENTS.CHANGE_NODE_COLOR:
      {
        const nodes = get(templateNodesAtom);
        set(templateNodesAtom, nodes.map(node => node.id === action.nodeId ? {
          ...node,
          color: action.color
        } : node));
        return;
      }
    case UNDOABLE_EVENTS.ADD_NODE:
    case UNDOABLE_EVENTS.DELETE_NODE:
    case UNDOABLE_EVENTS.ADD_EDGE:
    case UNDOABLE_EVENTS.DELETE_EDGE:
    case UNDOABLE_EVENTS.CLEAR_CANVAS:
      set(undoRedoDispatchAtom, action);
      return;
  }
});